console.log("careers")

import _forEach from 'lodash/forEach'

const form = new Vue({
  el: '#careersform',
  data() {
    return {
      form: {
        name: '',
        surnames: '',
        email: '',
        phone: '',
        birthdate: '',
        comments: '',
        resume: '',
        'g-recaptcha-response': '',
        terms: false,
      },
      default: {
        name: '',
        surnames: '',
        email: '',
        phone: '',
        birthdate: '',
        comments: '',
        resume: null,
        'g-recaptcha-response': '',
        terms: false,
      },
      validation: {
        name: 'required',
        surnames: 'required',
        email: 'required',
        phone: 'required',
        birthdate: 'required',
        comments: 'required',
        // resume: 'required',
        // 'g-recaptcha-response': '',
      },
      errors: {
        name: false,
        surnames: false,
        email: false,
        phone: false,
        birthdate: false,
        comments: false,
        resume: false,
        'g-recaptcha-response': false,
        terms: false,
      },
      resumeFile: "",
      resumeName: "",
      requestStatus: 'unsent',
    }
  },

  methods: {

    validateInputs() {
      let hasErrors = false;
      _forEach(this.validation, (field, key) => {
        this.errors[key] = false
        if(!this.form[key].length){
          this.errors[key] = true
          hasErrors = true
        }
      })

      this.errors.resume = false
      if(!this.resumeFile){
        this.errors.resume = true
          hasErrors = true
      }

      if(this.resumeFile){
        if(this.resumeFile.type !== 'application/pdf'){
          this.errors.resume = true
          hasErrors = true
        }

        if(this.resumeFile.size > 1000000){
          this.errors.resume = true
          hasErrors = true
        }

        if(!this.errors.resume){
          this.form.resume = this.resumeFile
        }

      }

      this.errors.terms = false
      if(!this.form.terms){
        this.errors.terms = true
          hasErrors = true
      }

      if(hasErrors)
        return false

      return true
    },

    getRecaptchaResponse(){
      this.form['g-recaptcha-response'] = $('#g-recaptcha-response').val()
    },

    sendData(){
      let formData = new FormData()

      _forEach(this.form, (field, key) => {
        formData.append(key, field)
      })
      // for(var pair of formData.entries()) {
      //    console.log(pair[0]+ ', '+ pair[1]);
      // }

      axios.post(this.$el.action, formData)
      .then(response => {
        if(response.data.status == 'success'){
          this.requestStatus = 'sent'
          this.clearForm()
        } else{
          console.log(response)
        }
      })
      .catch(error => {
        this.requestStatus = 'error'
        console.log(error)
      })
      .then(() => {
        setTimeout(() => {
          this.requestStatus = 'unsent'
        }, 8000)
      })
    },

    clearForm() {
      this.form = Object.assign(this.form, this.default)
      this.resumeFile = null
      this.resumeName = ""
    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.resumeFile = files[0];
      this.resumeName = this.resumeFile.name;
    },

    submit(){
      if(this.validateInputs()){
        this.getRecaptchaResponse()

        if(this.requestStatus == 'unsent'){
          this.requestStatus = 'sending'
          this.sendData()
        }

      }
    }
  }
});
